import React, { useState, useEffect } from "react";

import useClasses from "hooks/useClasses";
import Icon from "@mui/material/Icon";
import HourglassFullIcon from "@mui/icons-material/HourglassFull";

import GridItem from "components/Shared/Grid/GridItem.js";
import GridContainer from "components/Shared/Grid/GridContainer.js";
import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";

import styles from "./CompanyNumbersStyle";

function nFormatter(num) {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });
  return item
    ? (num / item.value).toFixed(1).replace(rx, "$1") + item.symbol
    : "0";
}

export default function CompanyNumbers({ companyNumbers }) {
  const [showWaiting, setShowWaiting] = useState(false);
  const [showCollected, setShowCollected] = useState(false);
  const [showNotCollected, setShowNotCollected] = useState(false);
  const [showArchived, setShowArchived] = useState(false);
  const classes = useClasses(styles);

  return (
    <div>
      {companyNumbers && (
        <GridContainer>
          <GridItem xs={12} sm={6} md={3}>
            <Card
              style={{ minHeight: "130px", cursor: "pointer" }}
              onClick={() => setShowWaiting((prev) => !prev)}
            >
              <CardHeader color="warning" icon>
                <HourglassFullIcon />
              </CardHeader>
              <CardBody>
                <p className={classes.cardCategory}>Waiting Recycables</p>
                <h3
                  className={classes.cardTitle}
                  onMouseEnter={() => setShowWaiting(true)}
                  onMouseLeave={() => setShowWaiting(false)}
                >
                  {showWaiting
                    ? companyNumbers.count_collectables_waiting
                    : nFormatter(companyNumbers.count_collectables_waiting)}
                </h3>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card
              style={{ minHeight: "130px", cursor: "pointer" }}
              onClick={() => setShowCollected((prev) => !prev)}
            >
              <CardHeader color="success" icon>
                <Icon>check</Icon>
              </CardHeader>
              <CardBody>
                <p className={classes.cardCategory}>Collected Recycables</p>
                <h3
                  className={classes.cardTitle}
                  onMouseEnter={() => setShowCollected(true)}
                  onMouseLeave={() => setShowCollected(false)}
                >
                  {showCollected
                    ? companyNumbers.count_collectables_collected
                    : nFormatter(companyNumbers.count_collectables_collected)}
                </h3>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card
              style={{ minHeight: "130px", cursor: "pointer" }}
              onClick={() => setShowNotCollected((prev) => !prev)}
            >
              <CardHeader color="danger" icon>
                <Icon>close</Icon>
              </CardHeader>
              <CardBody>
                <p className={classes.cardCategory}>Not Collected</p>
                <h3
                  className={classes.cardTitle}
                  onMouseEnter={() => setShowNotCollected(true)}
                  onMouseLeave={() => setShowNotCollected(false)}
                >
                  {showNotCollected
                    ? companyNumbers.count_collectables_not_collected
                    : nFormatter(
                        companyNumbers.count_collectables_not_collected
                      )}
                </h3>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card
              style={{ minHeight: "130px", cursor: "pointer" }}
              onClick={() => setShowArchived((prev) => !prev)}
            >
              <CardHeader color="secondary" icon>
                <Icon>timer_off</Icon>
              </CardHeader>
              <CardBody>
                <p className={classes.cardCategory}>Archived Requests</p>
                <h3
                  className={classes.cardTitle}
                  onMouseEnter={() => setShowArchived(true)}
                  onMouseLeave={() => setShowArchived(false)}
                >
                  {showArchived
                    ? companyNumbers.count_collectables_archived
                    : nFormatter(companyNumbers.count_collectables_archived)}
                </h3>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      )}
    </div>
  );
}
